export enum ProfilePersonalGenderType {
  DEFAULT = "DEFAULT",
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
  PREFER_NOT_TO_SAY = "PREFER_NOT_TO_SAY"
}